"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodes = void 0;
var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["GITHUB_API_RATE_LIMIT"] = "GITHUB_API_RATE_LIMIT";
    ErrorCodes["GITHUB_AUTH_EXPIRED"] = "GITHUB_AUTH_EXPIRED";
    ErrorCodes["GITHUB_PERMISSION_DENIED"] = "GITHUB_PERMISSION_DENIED";
    ErrorCodes["CONTENT_VALIDATION_FAILED"] = "CONTENT_VALIDATION_FAILED";
    ErrorCodes["NETWORK_ERROR"] = "NETWORK_ERROR";
    ErrorCodes["FILE_NOT_FOUND"] = "FILE_NOT_FOUND";
    ErrorCodes["INVALID_CONTENT_FORMAT"] = "INVALID_CONTENT_FORMAT";
})(ErrorCodes || (exports.ErrorCodes = ErrorCodes = {}));
